import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

const useFSC = () => {
  const { leadId } = useParams();
  const values = useSelector((state) => state?.leads?.byIds?.[leadId]);
  const [data, setData] = useState({});

  const profileCode = useSelector((state) => state?.lookup?.profile?.fscCode || '');
  const list = useSelector((state) => state?.lookup?.fsc || []);

  React.useEffect(() => {
    const { fscCode = '', fscName = '' } = values || {};
    let code = fscCode || profileCode;
    let allOptions = [{ value: '', label: 'Chọn...' }, ...list];

    setData({ code, name: fscName, allOptions });
  }, [values, list, profileCode]);

  return data;
};

export default useFSC;
